import sr from './sr';
import { latinToCyrillicSerbian } from '@/lib/i18n/latinToCyrillicSerbian';

const srCyrl: Record<string, string> = {};
for (const [key, value] of Object.entries(sr)) {
  srCyrl[key] = latinToCyrillicSerbian(value);
}

export default srCyrl;
